<template>
  <div id="grn-edit" class="group-setup">
    <!-- GRN Editing -->
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Edit GRN"></HeaderDividerBlock>
            <v-row>
              <!-- PO Number -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">PO Number</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.po_number"
                  required
                  clearable
                  placeholder="Select PO Number"
                  :items="purchaseOrders"
                  item-text="po_number"
                  item-value="po_number"
                  no-data-text="Search PO number"
                ></v-autocomplete>
              </v-col>
              <!-- GRN Date -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">GRN Date</p>
                </v-col>
                <DatePicker
                  v-model="form.grn_date"
                  placeholder="GRN Date"
                ></DatePicker>
              </v-col>

              <!-- Remarks -->
              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Remarks</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  placeholder="Remarks"
                  v-model="form.remarks"
                  required
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- GRN Items -->
            <v-col cols="12" md="12" sm="12">
              <GrnEditItems
                :products="products"
                :InitialGrnItems="products"
                :grnNumber="this.grn_number"
                :batches="batches"
                @total="handleTotal"
                @items="handleItems"
              />
            </v-col>

            <!-- Summary -->
            <!-- <v-col cols="12" md="6" sm="12">
              <v-col>
                <v-col class="ma-0 pa-0">
                  <p class="text-h5 font-weight-bold">Summary</p>
                </v-col>
                <v-col class="px-7 pa-10 total-section">
                  <v-row class="justify-space-between">
                    <p class="text-subtitle-1 font-weight-bold">Sub Total</p>
                    <p>{{ calculateSubtotal() }}</p>
                  </v-row>
                  <v-row class="justify-space-between">
                    <p class="text-subtitle-1 font-weight-bold">
                      Discount Amount
                    </p>
                    <p>{{ calculateTotalDiscount() }}</p>
                  </v-row>
                  <v-row class="justify-space-between">
                    <p class="text-subtitle-1 font-weight-bold">Tax Amount</p>
                    <p>{{ calculateTotalTax() }}</p>
                  </v-row>
                  <v-row class="justify-space-between">
                    <p class="text-subtitle-1 font-weight-bold">Grand Total</p>
                    <p>{{ calculateGrandTotal() }}</p>
                  </v-row>
                </v-col>
              </v-col>
            </v-col> -->

            <!-- Submit Button -->
            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('grn.edit')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                    >Update GRN</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import GrnEditItems from "@/components/grn/GrnEditItems";
import { GrnService } from "@/services/grn-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "EditGrnForm",
  components: {
    Alert,
    Snackbars,
    DatePicker,
    HeaderDividerBlock,
    GrnEditItems,
  },
  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      po_number: "",
      grn_date: new Date().toISOString().substr(0, 10),
      sub_total: 0.0,
      discount_amount: 0.0,
      tax_amount: 0.0,
      grand_total: 0.0,
      remarks: "",
      items: [],
    },
    branches: [],
    products: [],
    purchaseOrders: [],
    grnItems: [],
    batches: [],
    grn_number: "",
    grn_id: "",
    search: "",
    loadingBranches: false,
    loadingProducts: false,
    loadingPurchaseOrders: false,
    loadingBatches: false,
    role: localStorage.getItem("role") || null,
  }),

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },

  watch: {
    "form.po_number": async function(newPoNumber) {
      // Fetch products if PO Number is selected
      if (newPoNumber) {
        console.log("new po number : ", newPoNumber);
        try {
          this.loadingProducts = true;
          const products = await GrnService.getItemsByPoNumber(newPoNumber);

          this.products = products; // Store the products for the selected PO
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingProducts = false;
        }
      }
    },
  },
  created() {
    this.fetchGrnDetails();
    this.fetchBranchesSuppliersProducts();
    this.fetchBatches();
  },

  methods: {
    async fetchBatches() {
      console.log("batches method called");

      try {
        this.loadingBatches = true;
        const batches = await GrnService.getBatchList2(this.search);

        this.batches = batches.data.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingBatches = false;
      }
    },
    async submit() {
      this.loading = true;
      try {
        // Prepare form data
        const formData = { ...this.form };
        formData.items = this.form.items.map((item) => ({
          product_code: item.product_code,
          batch_id: item.batch_id,
          description: item.description,
          quantity_received: item.quantity_received,
          unit_price: item.unit_price,
          discount_percent: item.discount_percent,
          discount_amount: item.discount_amount,
          tax_percent: item.tax_percent,
          tax_amount: item.tax_amount,
          total_price: item.total_price,
        }));
        console.log("form data is : ", formData);
        // Call the GRN update service
        const response = await GrnService.updateGrn(this.grn_number, formData);

        // Handle success
        this.succesMsg = response.message;
        this.snackbar = true;
        this.$router.push({ name: "grn" }); // Redirect to the GRN list page
      } catch (error) {
        // Handle error
        console.error("Error updating GRN:", error);
        this.errors = "There was an error updating the GRN.";
      } finally {
        this.loading = false;
      }
    },

    async fetchBranchesSuppliersProducts() {
      try {
        this.loadingBranches = true;
        this.loadingProducts = true;
        this.loadingPurchaseOrders = true;

        const branches = await GrnService.getBranches();
        const purchaseOrders = await GrnService.getPurchaseOrders();
        const products = await GrnService.getItemsByGrnNumber(this.grn_id);

        this.branches = branches.data;
        this.purchaseOrders = purchaseOrders.data; // Ensure this has the correct structure
        this.products = products;

        console.log("Fetched Purchase Orders:", this.purchaseOrders);
        console.log("Fetched Products:", this.products);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        this.loadingBranches = false;
        this.loadingProducts = false;
        this.loadingPurchaseOrders = false;
      }
    },

    async fetchGrnDetails() {
      try {
        const response = await GrnService.getGrnDetails(
          this.$route.params.uuid
        );
        if (response) {
          const grnData = response;
          this.grn_id = grnData.id;
          this.grn_number = grnData.grn_number;
          this.form.po_number = grnData.po_number;
          this.form.grn_date = grnData.grn_date;
          this.form.remarks = grnData.remarks;
          console.log("Fetched PO Number:", this.form.po_number);
        }
      } catch (error) {
        console.error("Error fetching GRN details:", error);
      }
    },

    calculateSubtotal() {
      let subtotal = 0;
      this.form.items.forEach((item) => {
        subtotal += item.quantity_received * item.unit_price;
      });
      this.form.sub_total = subtotal;
      return parseFloat(subtotal);
    },

    calculateTotalDiscount() {
      let discount = 0;
      this.form.items.forEach((item) => {
        console.log("item discount am : ", item.discount_amount);
        discount += item.discount_amount;
      });
      this.form.discount_amount = discount;
      return parseFloat(this.form.discount_amount);
    },

    calculateTotalTax() {
      let tax = 0;
      this.form.items.forEach((item) => {
        tax += item.tax_amount;
      });
      this.form.tax_amount = tax;
      return parseFloat(tax);
    },

    calculateGrandTotal() {
      let grandTotal =
        parseFloat(this.calculateSubtotal()) -
        parseFloat(this.calculateTotalDiscount()) +
        parseFloat(this.calculateTotalTax());
      this.form.grand_total = grandTotal;
      return grandTotal;
    },

    handleItems(items) {
      this.form.items = items;
      console.log("item in form : ", this.form.items);
    },

    handleTotal(total) {
      this.form.total_amount = total;
      console.log("total in form : ", this.form.total_amount);
    },
  },
};
</script>
